import { UI } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { IconButton } from 'native-base';
import React from 'react';

export interface AccordionButtonProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const AccordionButton: React.FC<AccordionButtonProps> = ({ isOpen, setIsOpen }) => {
  return (
    <IconButton
      p={0}
      pl={Spacing['inline.nano']}
      variant="unstyled"
      onPress={() => setIsOpen(!isOpen)}
      icon={
        <UI.Icon
          name={isOpen ? 'ChevronUp' : 'ChevronDown'}
          size={'xxs'}
          color={Color['neutral.black']}
        />
      }
    />
  );
};
